module.exports = __webpack_public_path__ + "img/weddings_09_V.fc702433.webp";